export default defineNuxtRouteMiddleware(async () => {
    const { logout: logoutMiddleware } = useSanctumAuth()
    const currentStore = useCurrentStoreStore()
    const shopCartStore = useShopCartStore()

    const maxInactiveTime = 60 * 60 * 1000

    let inactivityTimer: ReturnType<typeof setInterval> | undefined

    const logout = async () => {
        await logoutMiddleware()

        shopCartStore.clearCart()
        currentStore.clearCurrentStore()

        localStorage.removeItem("lastActivityTime")

        await navigateTo("/")

        refreshNuxtData()
    }

    const updateLastActivity = () => {
        const now = Date.now()

        localStorage.setItem(
            "lastActivityTime",
            now.toString()
        )
    }

    const checkActivity = async () => {
        const lastActivity = Number(
            localStorage.getItem("lastActivityTime")
        )

        if (!lastActivity) {
            updateLastActivity()
            return
        }

        const inactiveTime = Date.now() - lastActivity

        if (inactiveTime >= maxInactiveTime) {
            clearInterval(inactivityTimer)
            await logout()
        }
    }


    if (import.meta.client) {

        const events = [
            "mousemove",
            "keypress",
            "click",
            "scroll"
        ]

        events.forEach(event =>
            document.addEventListener(
                event,
                updateLastActivity,
                { passive: true }
            )
        )


        inactivityTimer = setInterval(
            checkActivity,
            5 * 60 * 1000
        )

        checkActivity()
    }
})